// ABOUTME: Central registry for company-specific UI overrides.
// ABOUTME: Collects all company override definitions for use by the override hook.

import { assistedSellingOverride } from './assisted-selling';
import { fiammOverride } from './fiamm';
import { CompanyOverride } from './types';

export const companyOverrides: CompanyOverride[] = [fiammOverride, assistedSellingOverride];
